<template>
  <HRApprovalCard
    :approval="approval"
    :documents="documents"
    :saving="approvalSaving"
    :disable="approval.approvalStatus !== HR_APPROVAL_STATUSES.pending.value"
    :approval-status="approval.approvalStatus"
    :applicant-name="approval.employeeName"
    :employer-name="approval.erpOrgName"
    :loading-quote-pdf="loadingQuotePDF"
    :loading-contract-pdf="loadingContractPdf"
    :opening-agreement="openingAgreement"
    :application="application"
    :is-novated-contract="true"
    @open-agreement="openAgreement"
    @download:contract="openContractDocument"
  />
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { getAsset } from 'ecx.saigon.ui.common';
import { HR_APPROVAL_STATUSES } from '../../utils/constants';

export default {
  name: 'HRApprovalContractWidget',
  data() {
    return {
      HR_APPROVAL_STATUSES,
      documents: [],
      selectedDecision: undefined
    };
  },
  computed: {
    ...mapState('hr', [
      'quotePDFHref',
      'loadingQuotePDF',
      'loadingContractPdf',
      'openingAgreement',
      'approval',
      'approvalLoading',
      'approvalSaving',
      'application'
    ]),
    ...mapGetters('user', ['getBrandDocuments']),
    ...mapGetters('hr', ['acceptedQuoteId'])
  },
  methods: {
    ...mapActions('hr', [
      'openContractAgreement',
      'openContract',
      'getQuotePDF'
    ]),
    async openQuoteDocument() {
      if (!this.quotePDFHref) {
        await this.getQuotePDF(this.acceptedQuoteId);
      }
      const win = window.open(this.quotePDFHref, '_blank');
      if (win && win.focus) {
        win.focus();
      }
    },
    async openAgreement() {
      const url = await this.openContractAgreement();

      const win = window.open(url, '_blank');
      if (win && win.focus) {
        win.focus();
      }
    },
    async openContractDocument() {
      const url = await this.openContract();

      const win = window.open(url, '_blank');
      if (win && win.focus) {
        win.focus();
      }
    },
    back() {
      this.$router.push({ name: this.$RouteNames.hrApprovals });
    }
  },
  async mounted() {
    const brandDocuments = this.getBrandDocuments;
    const agreementUrl = await getAsset(brandDocuments.novatedServiceAgreement);
    const termsUrl = await getAsset(brandDocuments.leaseTerms);
    this.documents = [
      {
        label: 'Novation of a Finance Lease',
        href: agreementUrl
      },
      {
        label: 'Terms & Conditions',
        href: termsUrl
      }
    ];
  },
  components: {
    HRApprovalCard: () => import('../../components/organism/hr-approval-card')
  }
};
</script>
